/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Map from 'fierry/type/map';
import HexGroup from 'solis/type/hex/group';

import SimpleZone from 'solis/react/board/data/simple.zone';


export default class
{
  constructor ({ hexes })
  {
    this.hexes = hexes;

    this.zones = new Map(this.hexes.map(hex => [ hex, new SimpleZone(hex, this) ]));
  }


  equals (other)
  {
    return other?.constructor === this.constructor && new HexGroup(this.hexes).equals(new HexGroup(other.hexes));
  }


  getCenterDisplayHex ()
  {
    return new HexGroup(this.hexes).getCenter();
  }


  getZone (displayHex)
  {
    return this.zones.get(displayHex);
  }


  getZones ()
  {
    return this.zones.values();
  }


  getSelectableZone (displayHex)
  {
    return this.getZone(displayHex);
  }


  toEntityHex (displayHex)
  {
    return displayHex;
  }


  toDisplayHex (entityHex)
  {
    return entityHex;
  }


};
